"use client";

import { useState } from "react";
import { EyeIcon, EyeOffIcon, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type Props = {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	name?: string;
	autoComplete?: string;
	required?: boolean;
	className?: string;
	"aria-invalid"?: boolean;
	"aria-describedby"?: string;
};

export default function PasswordInput({
	value,
	onChange,
	placeholder = "Password",
	name = "password",
	autoComplete = "current-password",
	required,
	className,
	"aria-invalid": ariaInvalid,
	"aria-describedby": ariaDescribedBy,
}: Props) {
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div className="relative">
			<Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-(--card-foreground) w-4 h-4 pointer-events-none" />
			<Input
				type={isVisible ? "text" : "password"}
				name={name}
				autoComplete={autoComplete}
				placeholder={placeholder}
				className={cn("pl-10 pr-10 text-(--foreground)", className)}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				required={required}
				aria-invalid={ariaInvalid}
				aria-describedby={ariaDescribedBy}
			/>
			<button
				type="button"
				onClick={() => setIsVisible((v) => !v)}
				className="absolute inset-y-0 end-0 flex w-9 items-center justify-center text-muted-foreground"
				aria-label={isVisible ? "Nascondi password" : "Mostra password"}
				tabIndex={-1}
			>
				{isVisible ? (
					<EyeOffIcon
						size={16}
						className="cursor-pointer text-(--card-foreground)"
					/>
				) : (
					<EyeIcon
						size={16}
						className="cursor-pointer text-(--card-foreground)"
					/>
				)}
			</button>
		</div>
	);
}
